import { Box, Modal, Typography } from "@mui/material";
import hospital from "../../../assets/image/hospital.png";
import { archiveAllDrug } from "../../../api/group";
import { useState } from "react";
import { Loader } from "@/components/loader";

export default function ArchiveDrugsPop({
  open,
  setOpen,
  selectedDrugs,
  onArchive,
}) {
  const [loading, setLoading] = useState(false);
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "60vw",
          height: "20vw",
          bgcolor: "white",
          minWidth: "900px",
          minHeight: "350px",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
          ":focus-visible": {
            outline: "none !important",
            border: "none !important",
          },
        }}
      >
        <Box display="flex" alignItems="center" gap="20px">
          <Box width="40%" borderLeft="1px solid #98C2CB" height={"350px"}>
            <img src={hospital} />
          </Box>
          <Box width={"60%"} display="" height="350px">
            <Typography fontSize={"18px"} fontWeight="bold">
              آیا از آرشیو کردن تمامی داروهای انتخابی مطمئن هستید؟
            </Typography>

            <Box display="flex" sx={{ marginTop: "30px" }}>
              <Box
                width="100px"
                height="40px"
                borderRadius="10px"
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                color="#686A97"
                marginInlineEnd={"20px"}
                sx={{
                  cursor: "pointer",
                  border: "1px solid",
                  borderColor: "#686A97",
                }}
                onClick={async () => {
                  setLoading(true);
                  archiveAllDrug({
                    ids: selectedDrugs.map((itr) => itr.drugId),
                  })
                    .then((res) => {
                      onArchive();
                    })
                    .catch(() => {})
                    .finally(() => setLoading(false));
                }}
              >
                {"بله"}
              </Box>
              <Box
                bgcolor="var(--emr-red)"
                width="100px"
                height="40px"
                borderRadius="10px"
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                color="white"
                marginInlineEnd={"20px"}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                {"انصراف"}
              </Box>
            </Box>
          </Box>
        </Box>
        {loading && <Loader />}
      </Box>
    </Modal>
  );
}
